import React from "react";
import "./App.css";
import { FaFacebookF, FaTwitter, FaGithub, FaLinkedin } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <img src="./LOGO.png" alt="logo" className="logo-footer" />
          <p>
            Generate high-quality paragraphs instantly using AI.
            Enter any topic and get a well-written paragraph in seconds.
          </p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <a href="/">Home</a>
          <a href="/About">About</a>
          <a href="/Services">Services</a>
          <a href="/Portfolio">Portfolio</a>
        </div>

        <div className="footer-section">
          <h3>AI Tools</h3>
          <a href="/">Paragraph Generator</a>
          <a href="/">Essay Generator</a>
          <a href="/">Content Writer</a>
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>

          <div className="social-icons">
            <a href="https://www.facebook.com/"><FaFacebookF /></a>
            <a href="https://x.com/"><FaTwitter /></a>
            <a href="https://github.com/"><FaGithub /></a>
            <a href="https://www.linkedin.com/"><FaLinkedin /></a>
          </div>

        </div>

      </div>

      <div className="footer-bottom">
        © 2026 PRO AI Paragraph Generator. All rights reserved.
      </div>

    </footer>
  );
}

export default Footer;
